import { useState } from "react";
import { ChevronLeft, ChevronRight, Crown, Skull, LocateFixed } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function RegionNav({ game, viewIdx, setViewIdx, region }) {
  const [jump, setJump] = useState("");
  const total = game.total_regions;
  const done = game.wolf.highest_cleared;
  const go = (i) => setViewIdx(Math.max(1, Math.min(total, i)));
  const pct = (done / total) * 100;
  const milestone = region?.boss_kind === "milestone" || region?.boss_kind === "final";

  return (
    <div className="mb-5 space-y-4" data-testid="region-nav">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-[0.3em] font-mono-game text-cyan-300/80">
            Region <span data-testid="region-nav-index">{viewIdx}</span> of {total.toLocaleString()}
          </p>
          <h1 className="font-display text-3xl sm:text-4xl text-amber-100 truncate" data-testid="region-nav-name">{region?.name || "…"}</h1>
          {region && (
            <p className={`text-xs mt-1 flex items-center gap-1.5 ${milestone ? "text-red-300" : "text-slate-400"}`} data-testid="region-nav-boss">
              {milestone ? <Crown className="w-3.5 h-3.5" /> : <Skull className="w-3.5 h-3.5" />}
              {region.boss_kind === "final" ? "Final boss: " : milestone ? "Milestone boss: " : "Warden: "}{region.boss_name}
            </p>
          )}
        </div>
        <div className="flex items-center gap-1.5">
          <button data-testid="region-prev-btn" disabled={viewIdx <= 1} onClick={() => go(viewIdx - 1)} className="p-2 rounded-full border border-slate-700 hover:border-fuchsia-500 disabled:opacity-30" aria-label="Previous region"><ChevronLeft className="w-4 h-4" /></button>
          <form onSubmit={(e) => { e.preventDefault(); const n = parseInt(jump, 10); if (n) go(n); setJump(""); }}>
            <Input data-testid="region-jump-input" value={jump} onChange={(e) => setJump(e.target.value.replace(/\D/g, ""))} placeholder="Go to #" className="w-20 h-9 bg-slate-900 text-center text-xs" />
          </form>
          <button data-testid="region-next-btn" disabled={viewIdx >= total} onClick={() => go(viewIdx + 1)} className="p-2 rounded-full border border-slate-700 hover:border-fuchsia-500 disabled:opacity-30" aria-label="Next region"><ChevronRight className="w-4 h-4" /></button>
          {viewIdx !== game.wolf.region_idx && (
            <button data-testid="region-current-btn" onClick={() => setViewIdx(game.wolf.region_idx)} className="flex items-center gap-1 px-3 py-2 rounded-full text-xs bg-fuchsia-500/20 text-fuchsia-200 hover:bg-fuchsia-500/30">
              <LocateFixed className="w-3.5 h-3.5" />Where I am
            </button>
          )}
        </div>
      </div>
      <div data-testid="journey-progress">
        <div className="flex justify-between text-[11px] font-mono-game text-slate-400 mb-1">
          <span>JOURNEY TO MOONFANG PEAK</span><span data-testid="journey-progress-value">{done} / {total} cleared</span>
        </div>
        <div className="relative h-2 rounded-full bg-slate-900 border border-slate-800 overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-fuchsia-500 via-violet-500 to-cyan-400" style={{ width: `${Math.max(pct, done ? 0.6 : 0)}%` }} />
        </div>
      </div>
    </div>
  );
}
